module.exports = __webpack_public_path__ + "img/s5.0af9bfb5.png";